import { RouterMap } from '../../types';

export const routeMap: RouterMap = new Map();

routeMap.set('/messageCenter/notify', {
  name: 'MessageNotify',
});
